import React from "react";
import Reveal, { SplitWords } from "./Reveal";

export default function CoachWord() {
  return (
    <section id="word" className="relative py-28 md:py-40 border-b hairline">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        {/* Massive pull-quote */}
        <div className="grid md:grid-cols-[auto_1fr] gap-8 md:gap-16 items-start">
          <div className="font-display text-[120px] md:text-[220px] leading-[0.8] text-[var(--ember-2)] opacity-70">“</div>
          <div className="pt-4 md:pt-14">
            <Reveal>
              <p className="font-display italic text-[36px] md:text-[64px] leading-[1.06] tracking-[-0.02em] max-w-[1000px]">
                As iron sharpens iron, so one man sharpens another.
              </p>
            </Reveal>
            <div className="mt-6 font-mono text-[12px] uppercase tracking-[0.3em] text-[var(--text-muted)]">— Proverbs 27:17 —</div>
          </div>
        </div>

        <div className="rule my-16 md:my-24"></div>

        <div className="grid md:grid-cols-[1fr_1.4fr] gap-14">
          <div>
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[var(--text-muted)] mb-6">A Word from the Coach</div>
            <h3 className="font-display text-[42px] md:text-[64px] leading-[1] tracking-[-0.02em]">
              <SplitWords text="The mirror is a" />{" "}
              <span className="italic-serif text-[var(--ember-3)]"><SplitWords text="byproduct." /></span>
              <br />
              <SplitWords text="Not the point." />
            </h3>
          </div>

          <Reveal className="space-y-6 text-[17px] leading-[1.75] text-[var(--text-muted)] md:pt-6 max-w-[640px]">
            <p>Most men chase the body and lose the man. They sculpt the shell and let the soul go soft. They build the arms but neglect the marriage. They get the abs and lose the awe.</p>
            <p>2717 is built on the opposite premise.</p>
            <p>The body is a <span className="italic-serif text-[var(--text)]">byproduct</span> of the internal and external work done in private. The discipline. The repentance. The early mornings in the Word. The hard conversations with your wife. The "no" said to comfort. The "yes" said to Christ.</p>
            <p className="text-[var(--text)]"><strong className="font-medium">Do that work. Sincerely, daily, in community with other men. The body will follow.</strong> Not the other way around.</p>
            <p>That's what this brotherhood is for. Christian men who refuse to chase the shell. Men who train the body because it is worship, not because it is vanity.</p>
            <p className="text-[var(--ember-3)] italic-serif">If something in your chest just got tight, brother, you're in the right place.</p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
